export default __webpack_public_path__ + "static/media/audioSpeakers.1b011892.svg";